import React from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../../Assets/landingpageimage.jpg"; 
import Footer from "../footer/Footer";
import { Helmet } from "react-helmet-async";

const LandingPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col min-h-screen relative overflow-hidden">
      <Helmet>
        <link rel="canonical" href="https://puphub.co.in/" />
        <title>Welcome to PupHub — your pet's favorite social and professional companion app. Connect, discover, and thrive in the PupHub Universe!</title>
        <meta name="description" content="Welcome to PupHub — your pet's favorite social and professional companion app. Connect, discover, and thrive in the PupHub Universe!" />
      </Helmet>
      
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://puphub-customer.s3.ap-south-1.amazonaws.com/static_data/images/landingpageimage.jpg"
          alt="PupHub background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      </div>

      {/* Main Content */}
      <div className="flex-grow container mx-auto px-4 py-16 relative z-10">
        {/* Header */}
        <header className="text-center mb-16">
          <h1 className="relative text-3xl sm:text-5xl md:text-6xl font-extrabold text-white mb-6">
            <span className="relative z-10">
              Welcome to <span className="text-blue-400">PupHub Universe</span>
            </span>
            <span className="absolute inset-0 text-3xl sm:text-5xl md:text-6xl font-extrabold blur-md text-blue-500 opacity-70">
              Welcome to PupHub Universe
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-white max-w-3xl mx-auto">
            Where tails wag and pet dreams come true
          </p>
        </header>

        {/* Cards Section */}
        <div className="flex flex-col lg:flex-row gap-12 max-w-6xl mx-auto">
          {/* PupHub Family Card */}
          <div className="flex-1 bg-white/10 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden border border-white/20 transition-all duration-500 hover:shadow-[0_0_30px_rgba(59,130,246,0.8)] hover:-translate-y-3 hover:scale-105">
            <div className="bg-gradient-to-r from-blue-600 to-blue-400 p-6">
              <h2 className="text-3xl font-bold text-white text-center drop-shadow-lg">PupHub Family</h2>
              <p className="text-blue-100 text-center mt-2">For Pet Lovers</p>
            </div>
            <div className="p-8 text-white">
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="text-2xl mr-3">🐾</span>
                  <span>Connect with a community that loves pets as much as you do</span>
                </li>
                <li className="flex items-start">
                  <span className="text-2xl mr-3">📱</span>
                  <span>Share your pet's special moments and daily adventures</span>
                </li>
                <li className="flex items-start">
                  <span className="text-2xl mr-3">📍</span>
                  <span>Find trusted pet services in your neighborhood</span>
                </li>
                <li className="flex items-start">
                  <span className="text-2xl mr-3">💬</span>
                  <span>Exchange tips and stories with fellow pet enthusiasts</span>
                </li>
                <li className="flex items-start">
                  <span className="text-2xl mr-3">🤝</span>
                  <span>Chat directly with other pet parents</span>
                </li>
              </ul>
              <button
                onClick={() => navigate("/puphub")}
                className="mt-8 w-full bg-gradient-to-r from-blue-500 to-blue-700 hover:from-blue-600 hover:to-blue-800 text-white font-extrabold py-4 px-6 rounded-xl transition-all duration-500 shadow-lg hover:shadow-[0_10px_30px_rgba(59,130,246,0.8)] transform hover:-translate-y-1 hover:scale-105 active:scale-95"
              >
                Visit Our PupHub Page
              </button>
            </div>
          </div>

          {/* PupHub Pro Card */}
          <div className="flex-1 bg-white/10 backdrop-blur-md rounded-3xl shadow-2xl overflow-hidden border border-white/20 transition-all duration-500 hover:shadow-[0_0_30px_rgba(168,85,247,0.8)] hover:-translate-y-3 hover:scale-105">
            <div className="bg-gradient-to-r from-purple-600 to-purple-400 p-6">
              <h2 className="text-3xl font-bold text-white text-center drop-shadow-lg">PupHub Partner</h2>
              <p className="text-purple-100 text-center mt-2">For Pet Care Professionals</p>
            </div>
            <div className="p-8 text-white">
              <ul className="space-y-4">
                <li className="flex items-start">
                  <span className="text-2xl mr-3">✂️</span>
                  <span>Join our network of trusted pet care specialists</span>
                </li>
                <li className="flex items-start">
                  <span className="text-2xl mr-3">🏥</span>
                  <span>Connect with pet owners seeking your expertise</span>
                </li>
                <li className="flex items-start">
                  <span className="text-2xl mr-3">⭐</span>
                  <span>Showcase your services to a community of pet lovers</span>
                </li>
                <li className="flex items-start">
                  <span className="text-2xl mr-3">🛎️</span>
                  <span>Grow your business with our supportive platform</span>
                </li>
              </ul>
              <button
                onClick={() => navigate("/partner")}
                className="mt-8 w-full bg-gradient-to-r from-purple-500 to-purple-700 hover:from-purple-600 hover:to-purple-800 text-white font-extrabold py-4 px-6 rounded-xl transition-all duration-500 shadow-lg hover:shadow-[0_10px_30px_rgba(168,85,247,0.8)] transform hover:-translate-y-1 hover:scale-105 active:scale-95"
              >
                Visit Our Partner Page 
              </button>
            </div>
          </div>
        </div>

        {/* Footer Text */}
        <div className="text-center mt-16 max-w-3xl mx-auto">
          <p className="text-lg sm:text-xl text-white">
            From playful companions to professional care,
            <span className="font-bold text-blue-300"> PupHub</span> is where pets and their people connect and thrive together.
          </p>
        </div>
      </div>

      {/* Footer always at bottom */}
      <div className="relative">
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;